import React from "react";
import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { SEO } from "../components/seo";

export function NotFound() {
  return (
    <>
      <SEO 
        title="404 - Page Not Found"
        description="The requested page could not be found on ergys.dev"
        noindex={true}
      />
      <div className="min-h-screen flex items-center justify-center bg-black px-4">
        <div className="text-center">
          <h1 className="text-9xl font-black text-neutral-900 mb-4">404</h1>
          <h2 className="text-2xl font-black text-white uppercase tracking-tighter mb-8">Page Not Found</h2>
          <p className="text-neutral-500 mb-12 max-w-md mx-auto leading-relaxed">
            The page you are looking for might have been moved, deleted, or never existed in the first place.
          </p>
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-neutral-100 text-neutral-950 px-8 py-4 rounded-xl font-black uppercase tracking-tighter hover:bg-neutral-300 transition-all"
          >
            <ArrowLeft size={18} /> Return Home
          </Link>
        </div>
      </div>
    </>
  );
}